import { ChangeEvent } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import { Btn, H6, P } from "../../../../AbstractElements";
import { ContactDetails, Continue, Email, GekkoCo, InqMail, JoinOrganizationType, OrganizationDescription, OrganizationName, Previous, ShareYourProblemsAndAnotherIssues } from "../../../../Constant";
import { useAppDispatch, useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import ShowError from "../../common/ShowError";
import { BusinessFormCommonProps } from "../../../../Type/FormLayoutType";
import { setContactDetailsFormValue } from "../../../../Redux-Toolkit/Reducers/FormLayout/FormWizardTwoSlice";

const ContactDetailsForm = ({ callbackActive }: BusinessFormCommonProps) => {
  const {contactDetailsFormValues} = useAppSelector((state)=>state.formWizardTwo)
  const { organizationName, email, description, organizationType } = contactDetailsFormValues;
  const dispatch = useAppDispatch()

  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = event.target.value;
    dispatch(setContactDetailsFormValue({ ...contactDetailsFormValues, [name]: value }));
  };

  const handleNextButton = () => {
    if (organizationName !== "" &&email !== "" &&description !== "" &&organizationType !== "") { callbackActive(4) }
    else { ShowError() }  
  };

  return (
    <Form onSubmit={(event) => event.preventDefault()} className="g-3 needs-validation" noValidate>
      <Row>
      <Col xs="12">
        <H6>{ContactDetails}</H6>
        <P>Please visit the documentation page if you require further information.</P>
      </Col>
      <Col sm="6" className="mt-3">
        <Label check>{OrganizationName}<span className="txt-danger">*</span></Label>
        <Input type="text" placeholder={GekkoCo} name="organizationName" value={organizationName} onChange={getUserData}/>
      </Col>
      <Col sm="6" className="mt-3">
        <Label check>{Email}<span className="txt-danger">*</span></Label>
        <Input type="text" placeholder={InqMail} value={email} name="email" onChange={getUserData}/>
      </Col>
      <Col xs="12" className="mt-3">
        <Label check>{JoinOrganizationType}<span className="txt-danger">*</span></Label>
        <Input type="select" value={organizationType} name="organizationType" onChange={getUserData} className="f-w-400 f-14 text-gray">
          <option value={""}>Join organization type</option>
          <option value={"Technology"}>Technology</option>
          <option value={"Culture"}>Culture</option>
          <option value={"NGO "}>NGO </option>
          <option value={"Environment"}>Environment</option>
          <option value={"Life cycle"}>Life cycle</option>
        </Input>
      </Col>
      <Col xs="12" className="mt-3">
        <Label check>{OrganizationDescription}</Label>
        <Input type="textarea" value={description} name="description" onChange={getUserData} placeholder={ShareYourProblemsAndAnotherIssues}/>
      </Col>
      <Col xs="12" className="text-end mt-3">
        <Btn color="primary" onClick={() => callbackActive(2)}>{Previous}</Btn>
        <Btn className="ms-1" color="primary" onClick={handleNextButton}>{Continue}</Btn>
      </Col>
      </Row>
    </Form>
  );
};

export default ContactDetailsForm;
